module.exports = __webpack_public_path__ + "img/bgImg.edf3265d.png";